import React from 'react';
import {Image, Text, View} from '@aws-amplify/ui-react';
import { backgroundColor } from '../config/config';

export default function Header () {
  return (
    <View
    as="div"
    className='header'
    height="40px"
    width="auto"
    backgroundColor={backgroundColor}
  >
      <Image
        src="/assets/logo.svg"
        style={{marginLeft: 0.5 + 'em'}}
      />
      <Text>Reconocimiento Facial</Text>
    </View>
  );
}
